
import React, { createContext, useContext, ReactNode } from 'react';
import { translations } from '@/translations';

// Define available languages
export type Language = 'de';

// Create context type
type LanguageContextType = {
  language: Language;
  setLanguage: (language: Language) => void;
  t: (key: string) => string;
};

// Create context with default values
const LanguageContext = createContext<LanguageContextType>({
  language: 'de',
  setLanguage: () => {},
  t: () => '',
});

// Create provider component
export const LanguageProvider = ({ children }: { children: ReactNode }) => {
  // Now language is always "de" with no option to change
  const language: Language = 'de';
  
  // No-op function since we don't allow changing the language anymore
  const setLanguage = () => {
    console.log('Language is fixed to German');
  };

  // Translation function
  const t = (key: string): string => {
    if (!translations[key]) {
      console.warn(`Translation key "${key}" not found`);
      return key;
    }
    return translations[key][language];
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

// Custom hook for using language context
export const useLanguage = () => useContext(LanguageContext);
